import type { Route } from '@angular/router';
import { environment } from '@camino-solutions/core/environment';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: '',
    loadComponent: () => import('@camino-solutions/core/app/ui/app-layout'),
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/routes'),
      },
      {
        path: 'companies',
        loadChildren: () => import('@camino-solutions/domain/company/ui').then(m => m.routes),
      },
      {
        path: 'subscriptions',
        loadChildren: () => import('@camino-solutions/domain/subscription/ui'),
      },
      {
        path: 'templates',
        loadChildren: () => import('@camino-solutions/domain/template/ui'),
      },
      {
        path: 'page-flow',
        loadChildren: () => import('@camino-solutions/feature/page-flow/route'),
      },
      // Playground routes - only available in non-production environments
      ...(environment.name === 'production' || environment.name === 'fb-production'
        ? []
        : [
            {
              path: '',
              loadChildren: () =>
                import('@camino-solutions/playground').then(m => m.NewSessionTestPanelRoutes),
            },
          ]),
      {
        path: 'pivot',
        loadChildren: () => import('@camino-solutions/feature-pivot-route').then(m => m.routes),
      },
      {
        path: '',
        loadChildren: () => import('@camino-solutions/core/user/permission').then(m => m.routes),
      },
      {
        path: 'import',
        loadChildren: () => import('@camino-solutions/feature/local-import/ui').then(m => m.routes),
      },
      {
        path: 'approval',
        loadChildren: () =>
          import('@camino-solutions/feature-approval-panel-route').then(m => m.routes),
      },
      {
        path: 'dani',
        loadComponent: () => import('./dani/dani.component'),
      },
      {
        path: 'profile',
        loadChildren: () => import('@camino-solutions/domain/profile/ui'),
      },
    ],
  },
];
